import { render } from "./MenuTracking.vue?vue&type=template&id=1fc17bdc&scoped=true"
import script from "./MenuTracking.vue?vue&type=script&lang=js"
export * from "./MenuTracking.vue?vue&type=script&lang=js"

import "./MenuTracking.vue?vue&type=style&index=0&id=1fc17bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc17bdc"]])

export default __exports__